/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_OctInputs */

const en_better_studio_month_oct = /** @type {(inputs: Better_Studio_Month_OctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oct`)
};

/**
* | output |
* | --- |
* | "Oct" |
*
* @param {Better_Studio_Month_OctInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_oct = /** @type {((inputs?: Better_Studio_Month_OctInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_OctInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_oct(inputs)
});